import React, { Dispatch } from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import Modal from 'components/Modal';
import CompanyForm from 'components/forms/CompanyForm';
import { DICTIONARY } from 'shared/constants';

interface Props {
  isEdit?: boolean;
  open: boolean;
  setOpen: Dispatch<boolean>;
}

const CompanyModal: React.FC<Props> = ({ isEdit, open, setOpen }: Props) => (
  <Modal
    open={open}
    setOpen={setOpen}
    title={isEdit ? DICTIONARY.EditCompany : DICTIONARY.CreateCompany}
    titleIcon={BusinessIcon}
  >
    <CompanyForm setOpen={setOpen} isEdit={isEdit} />
  </Modal>
);

export default CompanyModal;
